module.exports = __webpack_public_path__ + "img/login-left-bg.395edb8a.png";